export default __webpack_public_path__ + "static/media/resources.e4e98212.wav";